import { FormControl } from '@angular/forms';

export const zipCodeValidator = (control: FormControl) => {
  const valid = /[0-9]{2}\-[0-9]{3}$/.test(control.value);

  if (control.value && !valid) {
    return {
      zipCode: false
    };
  }
  return null;
};
